export enum EtherUnit {
  wei = "wei",
  kwei = "kwei",
  mwei = "mwei",
  gwei = "gwei",
  szabo = "szabo",
  finney = "finney",
  ether = "ether",
}

export const ETHER_UNITS = [
  EtherUnit.wei,
  EtherUnit.kwei,
  EtherUnit.mwei,
  EtherUnit.gwei,
  EtherUnit.szabo,
  EtherUnit.finney,
  EtherUnit.ether,
];
